import { eDepositCategory } from './eDepositCategory';
import { eMatchedQueryValue } from '../../accounting/eMatchedQueryValue';
import { IEscrowActualIncomingCheckResponse } from '../../accounting/response/IEscrowActualIncomingChecksResponse';
import { ISODateTimeString } from '../../shared/ISODateTimeString';
import { ePayerType } from './ePayerType';

export interface ICheckDepositData {
  id: string;
  amountCents: number;
  payerType: ePayerType;
  category: eDepositCategory;
  actualIncomingCheck?: IEscrowActualIncomingCheckResponse;
  checkIdentifier: string;
  matched: eMatchedQueryValue;
  createdAt: ISODateTimeString;
  createdBy: string;
  updatedAt: ISODateTimeString;
  updatedBy?: string;
  version?: 'v1' | 'v2-fees' | 'v2-accounting';
  matchedAt: string;
  matchedBy: string;
  isEditing?: boolean;
}

export type ICheckDepositResponse = ICheckDepositData;

export const convertICheckDepositResponseToICheckDepositData = (data: ICheckDepositResponse): ICheckDepositData => data;
